import type { TransactionAction } from '@morpho-org/morpho-sdk'

import type { VaultExitType } from '@/app/api/t/constants'
import type { TxSourceFlow } from '@/lib/shared/utils/flags.constants'

type SdkActionType = TransactionAction['type']

// morpho-sdk stamps the action inside each built tx (`buildTx().action.type`)
// with the action factory that produced it; the withdraw-family vault actions
// split by which exit they encode.
const SDK_ACTION_TO_EXIT_TYPE = {
  vaultV2Withdraw: 'withdraw',
  vaultV2Redeem: 'redeem',
  vaultV2ForceWithdraw: 'forceWithdraw',
  vaultV2ForceRedeem: 'forceRedeem',
  vaultV1Withdraw: 'withdraw',
  vaultV1Redeem: 'redeem'
} as const satisfies Partial<Record<SdkActionType, VaultExitType>>

/** Which exit a vault withdraw-family action built, undefined for anything else (in-kind redeems included). */
export function getVaultExitType(sdkActionType: string | undefined): VaultExitType | undefined {
  if (!sdkActionType || !Object.hasOwn(SDK_ACTION_TO_EXIT_TYPE, sdkActionType)) return undefined
  return SDK_ACTION_TO_EXIT_TYPE[sdkActionType as keyof typeof SDK_ACTION_TO_EXIT_TYPE]
}

/** The tx* flow a Vault V2 withdraw-family action belongs to: force exits have their own flag. */
export function getVaultV2WithdrawFlow(
  sdkActionType: string | undefined
): Extract<TxSourceFlow, 'vaultV2Withdraw' | 'vaultV2ForceWithdraw'> {
  const exitType = getVaultExitType(sdkActionType)
  return exitType === 'forceWithdraw' || exitType === 'forceRedeem'
    ? 'vaultV2ForceWithdraw'
    : 'vaultV2Withdraw'
}
